import React, { Fragment } from 'react';
import { V2ChatIcon, V2CommunityIcon, V2EducationIcon, V2Phone2Icon, V2ResolutionIcon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { contactOptionIcons } from '../../common/constants';

function ContactOptionIcon({ type, size, className, ...rest }) {
  const renderContactOptionIcon = () => {
    switch (type) {
      case contactOptionIcons.COMMUNITY:
        return <V2CommunityIcon size={size} className={className} {...rest} />;
      case contactOptionIcons.CALLUS:
      case contactOptionIcons.PHONE:
        return <V2Phone2Icon size={size} className={className} {...rest} />;
      case contactOptionIcons.MESSAGE:
      case contactOptionIcons.CHAT:
      case contactOptionIcons.MESSAGE_US:
        return <V2ChatIcon size={size} className={className} {...rest} />;
      case contactOptionIcons.RES_CENTER:
      case contactOptionIcons.SELLER:
        return <V2ResolutionIcon size={size} className={className} {...rest} />;
      case contactOptionIcons.ARTICLE:
        return <V2EducationIcon size={size} className={className} {...rest} />;
      default:
        return null;
    }
  };

  return <Fragment>{renderContactOptionIcon()}</Fragment>;
}

ContactOptionIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default ContactOptionIcon;
